import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TextInput, DatePicker } from 'components'
import { IconSearch, IconClose } from 'components/Icons'
import type { IParamTicketAssignment } from 'features/Ticket'
import { parseDate, formatDate } from 'helpers/common'

function TicketAssignSearchAndFilter(props: {
  searchParams: IParamTicketAssignment
  setSearchParams: (params: IParamTicketAssignment) => void
}): JSX.Element {
  const { t } = useTranslation('ticket')

  const base = 'f-ticket-assign-header'
  const { searchParams, setSearchParams } = props
  const { q = '' } = searchParams
  const date = parseDate(searchParams.date) || new Date()

  const [search, setSearch] = useState<string>(q)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearch(e.target.value)
  }
  const handleSearchSubmit = () => setSearchParams({ q: search.trim() })
  const handleClearSearch = () => {
    setSearch('')
    setSearchParams({ q: '' })
  }

  const handleDateChange = (date: string) => setSearchParams({ date })

  return (
    <div className={base}>
      <TextInput
        placeholder={t('searchAssign.placeholder')}
        name='search'
        onChange={handleSearchChange}
        value={search}
        variants='secondary'
        withIcon={
          q && q === search ? (
            <span
              data-testid='search-assign-close'
              className={`${base}__in-line-btn`}
              onClick={handleClearSearch}
            >
              <IconClose variants='sm' />
            </span>
          ) : (
            <span
              data-testid='search-assign-search'
              className={`${base}__in-line-btn`}
              onClick={() => handleSearchSubmit()}
            >
              <IconSearch variants='sm' />
            </span>
          )
        }
      />
      <DatePicker
        value={date}
        onChange={(_date) => handleDateChange(formatDate(_date))}
        variants='secondary'
      />
    </div>
  )
}

export default TicketAssignSearchAndFilter
